module.exports = __webpack_public_path__ + "03f8edc1a6d213611699ddc59af9ac8f.svg";